import { inject, Injector } from '@angular/core';
import { AuthStore } from '@auth';
import { toObservable } from '@angular/core/rxjs-interop';
import { LoadingService } from '../services/loading.service';
import { Observable } from 'rxjs';

/**
 * Initializes the authentication flow by managing the loading indicator
 * based on the authentication state.
 */
export const authInit = (): Observable<boolean> => {
  const injector = inject(Injector);
  const authStore = inject(AuthStore);
  const loadingService = inject(LoadingService);

  /**
   * Convert `isAuthenticated` from `AuthStore` to an observable and subscribe to it.
   * It ensures the loading indicator is shown or hidden based on authentication state.
   */
  return new Observable((observer) => {
    toObservable(authStore.isAuthenticated, { injector }).subscribe(
      (isAuthenticated) => {
        if (isAuthenticated) observer.complete();
      },
    );
  });
};
